export enum VotingSessionType {
  Standard,
  FistToFive,
  Poker,
}
